import { PayUDepositActionResult } from "@models/C_Transactions";
import { PaymentsCommonErrorCodes } from "@models/MasterData";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { PaymentMethodConfig } from "@models/payments/PaymentMethodConfig";
import { ErrorService } from "@providers/ErrorService";
import { TrackingService } from "@providers/TrackingService";
import { NewBaseService } from "@providers/newBase.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { UserService } from "../UserService";
import { PaymentMethodBehaviour, RedirectMethodBehaviourResult, SkipAmountResult } from "./PaymentMethodBase";

export class PayUPaymentMethodBehaviour extends PaymentMethodBehaviour {
  behaviour = PaymentMethodConfig.PAYU.behaviour;
  name = this.behaviour.name; //"PayU"
  image = this.behaviour.image; //"PayU";
  track = this.behaviour.track; //"PayU";
  isBank = this.behaviour.isBank; //false;
  minDepositAmount = 100;
  maxDepositAmount = 999999999;
  amountButtons: number[] = [300, 400, 800, 100];
  amount = 400;

  deviceType: string = "mobile";
  isPSE: boolean;
  globalVars!: GlobalVarsModel;
  private newBaseService = new NewBaseService();

  constructor(userService: UserService, errorService: ErrorService, trackingService: TrackingService) {
    super(false, userService, errorService, trackingService);
    this.isPSE = false;
    this.newBaseService.getVars.subscribe((vars: GlobalVarsModel) => {
      this.globalVars = vars;
    });
  }
  skipAmountInput(): Observable<SkipAmountResult> {
    return new Observable<SkipAmountResult>();
  }

  paymentMetodExecution(): Observable<RedirectMethodBehaviourResult> {
    return this.userService.validatePayUDep(this.amount, this.deviceType, this.isPSE).pipe(
      map((obj) => {
        return this.map(obj);
      }),
      catchError((error, caught) => {
        this.trackCatchError(this.behaviour.name, { err: error, caught: caught });
        return of(<RedirectMethodBehaviourResult>this.getGenericErrorResult());
      }),
    );
  }

  private map(input: PayUDepositActionResult): RedirectMethodBehaviourResult {
    const result = new RedirectMethodBehaviourResult();
    const { UrlTransactionsApiBase } = this.globalVars;
    if (input.success) {
      result.success = true;
      const queryParams = this.buildQueryParams({
        merchantId: input.merchantId,
        referenceCode: input.referenceCode,
        description: input.description,
        amount: input.amount,
        signature: input.signature,
        accountId: input.accountId,
        currency: input.currency,
        buyerFullName: input.buyerFullName,
        buyerEmail: input.buyerEmail,
        responseUrl: input.responseUrl,
        confirmationUrl: input.confirmationUrl,
        url: input.url,
        tax: input.tax,
        taxReturnBase: input.taxReturnBase,
        paymentMethods: input.paymentMethods,
        phoneNumber: input.phoneNumber,
        payerDocument: input.payerDocument,
        payerDocumentType: input.payerDocumentType,
      });
      result.url = `${UrlTransactionsApiBase}Payments/GetPayUForm?${queryParams}`;
    } else {
      this.trackGenericError(this.behaviour.name, result);
      result.success = false;
      result.erroMessage = this.errorService.searchErrorCodeWithParams(
        "error" + input.errCode,
        input.errorParameters,
      );
      result.errorcode = input.errCode;
      result.sendToDocumentVerificationPage =
        input.errCode === PaymentsCommonErrorCodes.MUST_COMPLETE_DOC_VERIFICATION ||
        input.errCode === PaymentsCommonErrorCodes.LIMIT_NOT_VERIFIED_SURPASSED;
      result.sendToUserProfileForm =
        input.errCode === PaymentsCommonErrorCodes.DEPOSIT_CANNOT_PROCEED_WITHOUT_PHONE_NUMBER;
    }

    return result;
  }

  private buildQueryParams(params: Record<string, any>): string {
    return Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join("&");
  }
}

export class PayUPSEPaymentMethodBehaviour extends PayUPaymentMethodBehaviour {
  constructor(userService: UserService, errorService: ErrorService, trackingService: TrackingService) {
    super(userService, errorService, trackingService);
    this.isPSE = true;
  }
}
